const regexSplit = (pattern, s) => s.split(RegExp(pattern));

module.exports = { "regex.split": regexSplit };
